<template>

  <div class="d-flex flex-column col-12 col-lg-8 border-right p-0 border-left">
    <h1 class="section-header fw-bold pl-5 pb-3">Factors in Aggravation & Mitigation</h1>
    <!-- <h3 class="fs-3 fw-bold">Circumstances in Aggravation</h3> -->
    <!-- <h5 class="fs-5 fw-bold">Found</h5> -->



    <div class="d-flex w-100 pl-5 tab-hidden">
      <div class="tab" :class="category == 'Aggravating' ? 'tab-active' : 'tab-inactive'" @click="category = 'Aggravating'">
        Aggravation</div>
      <div class="tab" :class="category == 'Mitigating' ? 'tab-active' : 'tab-inactive'" @click="category = 'Mitigating'">
        Mitigation</div>
      <div class="tab border-right" :class="category == 'Concurrent' ? 'tab-active' : 'tab-inactive'"
        @click="category = 'Concurrent'">Concurrency</div>
      <!-- <button class="btn btn-xl tab-hidden">Aggravating</button>
        <button  class="btn btn-xl tab-hidden mx-3">Mitigating</button>
        <button  class="btn btn-xl tab-hidden">Concurrency</button>
        <select class="form-control-lg tab-show" v-model="category">
          <option value="Aggravating">Aggravating Circumstances</option>
          <option value="Mitigating">Mitigating Circumstances</option>
          <option value="Concurrent">Concurrency Circumstances</option>
        </select> -->
    </div>
    <div class="tab-show pl-5 mb-5">
      <select class="form-control " v-model="category">
      <option value="Aggravating">Aggravating Circumstances</option>
      <option value="Mitigating">Mitigating Circumstances</option>
      <option value="Concurrent">Concurrency Circumstances</option>
    </select>
    </div>
    
    <div class="overflow-auto  w-100 border-top ">
      <div class="d-flex w-100 justify-content-between py-3">
          <p class="fs-3  fw-bold pl-5" v-if="category == 'Aggravating'">California Rules of Court Rule 4.421</p>
          <p class="fs-3  fw-bold pl-5" v-else-if="category == 'Mitigating'">California Rules of Court Rule 4.423
          </p>
          <p class="fs-3  fw-bold pl-5" v-else-if="category == 'Concurrent'">California Rules of Court Rule 4.425
          </p>

          <button class="btn btn-primary btn-xl mr-3" @click="emitGenerateReport">Generate Report</button>
        
      </div>

      <table class="border-top  mb-5 w-100" v-if="circumstances.length > 0">
        <thead>
          <tr></tr>
          <th class=" pl-5" style="width: 5%;">True</th>
          <th class="" style="width: 70%;">Description</th>
          <th class="" style="width: 25%;"></th>
        </thead>
        <tbody>
          <tr class="selectable border-bottom" style="" v-for="circumstance in filteredCircumstances"
            :key="circumstance.Id">
            <td style="width: 5%;" class="  pl-5"><input :id="`circumstance-${circumstance.Id}`" type="checkbox"
                v-model="circumstance.checked" @click="toggleSelected(circumstance)"></td>
            <td style="width: 70%;" class="">
              <label :for="`circumstance-${circumstance.Id}`" class="fs-5 clickable m-0 p-0">{{ circumstance.Name
                }}</label>

            </td>
            <td style="width: 25%;" class="">
              <button class="btn btn-primary-outline btn-xl w-100" @click="emitPopupText({
                header: circumstance?.StatuteNumber,
                body: circumstance?.LawText
              })
                ">{{ circumstance?.StatuteNumber }}</button>
            </td>


          </tr>
        </tbody>
      </table>
    </div>


  </div>
</template>
<script>
import Modal from "../../../components/utils/Modal.vue";
import axios from "axios";
export default {
  name: "Circumstances",
  components: { Modal },
  props: ['caseSelected', 'caseCircumstances'],
  data() {
    return {
      circumstances: [],
      showAddCircumstanceModal: false,
      category: 'Aggravating'
    };
  },
  //   props: ["unselectedCircumstances"],
  computed: {
    unselectedCircumstances() {
      if (this.caseCircumstances?.length > 0) {
        const mappedCaseCircumstances = this.caseCircumstances.map(
          (caseCirc) => caseCirc.CircumstancesId
        );

        const selectedCircumstances = this.circumstances.filter(
          (circ) => !mappedCaseCircumstances.includes(circ.Id)
        );

        return selectedCircumstances;
      } else {
        return this.circumstances;
      }
    },
    selectedCircumstances() {
      if (this.caseCircumstances?.length > 0) {
        const mappedCaseCircumstances = this.caseCircumstances.map(
          (caseCirc) => caseCirc.CircumstancesId
        );

        const selectedCircumstances = this.circumstances.filter((circ) =>
          mappedCaseCircumstances.includes(circ.Id)
        );

        return selectedCircumstances;
      } else {
        return [];
      }
    },
    filteredCircumstances() {
      return this.circumstances.filter(c => c.Category == this.category)
    }
  },
  methods: {
    emitGenerateReport() {
      this.$emit("generateReport")
    },
    emitPopupText(text) {
      this.$emit("popupText", text);
    },
    async loadCircumstances() {
      const circumstances = await axios.get(
        process.env.VUE_APP_ENDPOINT + "/api/circumstances", {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      }
      );
      return circumstances.data.sort((a, b) => a.SortOrder - b.SortOrder);
    },
    isSelected(circumstance) {
      return this.caseCircumstances.map(c => c.CircumstancesId).includes(circumstance.Id)
    },
    toggleSelected(circumstance) {
      if (this.isSelected(circumstance)) {
        this.deleteCaseCircumstance(circumstance)
      } else {
        this.createCaseCircumstance(circumstance)
      }
    },

    async createCaseCircumstance(circumstance) {
      const caseCircumstance = await axios.post(
        process.env.VUE_APP_ENDPOINT + "/api/caseCircumstances", {
        CircumstancesId: circumstance.Id,
        CaseId: this.caseSelected.Id,
      },
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        }
      );
      this.caseCircumstances.push(caseCircumstance.data);

    },
    async deleteCaseCircumstance(circumstance) {
      const caseCircumstance = this.caseCircumstances.find(c => c.CircumstancesId == circumstance.Id)
      const deletedCaseCircumstance = await axios.delete(
        process.env.VUE_APP_ENDPOINT + `/api/caseCircumstances/${caseCircumstance.Id}`, {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      }
      )
      let foundIndex = this.caseCircumstances.findIndex(c => c.CircumstancesId == circumstance.Id)
      if (foundIndex == -1) {
        return
      }
      this.caseCircumstances.splice(foundIndex, 1)

    },
  },
  async mounted() {
    this.token = localStorage.getItem("user_token");
    this.currentCase = this.caseSelected;

    this.circumstances = await this.loadCircumstances();
    // this.caseCircumstances = await this.loadCaseCircumstances();
    this.circumstances.forEach(c => {
      c.checked = this.isSelected(c)
    })
  },
};
</script>
<style>
.full-container {}

@media (min-width: 1024px) {
  .full-container {
    width: 50vw;
  }
}
</style>
